export const isToday = (day, month, year) => {
  return new Date().getDate() === day && new Date().getFullYear() === year && new Date().getMonth() === month;
};
